import { useMutation } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useDeleteNotification() {
	return useMutation({
		mutationKey: ["notifications"],
		mutationFn: async (id: string) => {
			const res = await fetch(`${SERVICE_API}/api/notifications/${id}`, {
				method: "DELETE",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to delete notification");
			}

			return (await res.json()) as { deleted: boolean };
		},
	});
}
